import { ChangeDetectorRef, Component, ComponentFactoryResolver, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { SolarBaseComponent } from '@solar/solar/solar-base';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Site, InfoSite, Supervision } from 'solar-bo';;
import { AppConfig } from '@solar/app.config';
import { MessageError } from 'base-models';
import { AlertType } from 'base-models';
import { CountryPickerService, ICountry } from 'basecomponents';
import { DialogdeleteComponent } from 'basecomponents';
import { SortHelper } from 'shtools';
import { ErrorcontrolService } from 'basecomponents';

import { TableList } from 'shtools';
import { TabComponent } from '@solar/components/maintab/tab.component';
import { MainTabComponent } from '@solar/components/maintab/maintab.component';
import { MatTab, MatTabGroup } from '@angular/material/tabs';
import { TabItem } from '@solar/components/maintab/tabitem.model';
import { SupervisComponent } from '../superv-main/supervis.component';



@Component({
  selector: 'app-supervis-list-main',
  templateUrl: './supervis-list-main.component.html',
  styleUrls: ['./supervis-list-main.component.scss']
})
export class SupervisListMainComponent extends SolarBaseComponent implements OnInit {

  tabsComponents: TabItem[] = [];
  tab_selectedIndex = 0;
  //@ViewChild(MainTabComponent) tabsComponent:MainTabComponent;

  @ViewChild(MatTabGroup, { read: MatTabGroup }) public tabGroup: MatTabGroup;
  @ViewChildren(MatTab, { read: MatTab }) public tabNodes: QueryList<MatTab>;
  //@ViewChild('tablistcomp') tablistComp: TabsetComponent;


  constructor(private cdr: ChangeDetectorRef) {
    super();
    this.loading = false;

  }

  ngOnInit() {


  }

  supervisionSelectedEventHandler($event) {
    let supervision: Supervision = $event;
    //this.tabsComponent.openTab(site.name, SiteMainComponent, {siteId:site.id}, true);
    let tabExistIndex = this.findTabBy(supervision.id);
    if (tabExistIndex > -1) {
      this.tabGroup.selectedIndex = tabExistIndex + 1;//because we have at least 1 fixed we use total length
      return;
    }
    this.loadinglist = true;
    //setTimeout(() => this.loadinglist=true);    
    //this.cdr.detectChanges();
    setTimeout(() =>
      this.openTab(supervision.id, supervision.name, SupervisComponent, { id_supervision: supervision.id }, true)
    );

  }

  openTab(id: any, title: string, component, data, isCloseable = false) {

    let instance: TabItem = new TabItem();
    instance.id = id;
    instance.title = title;
    instance.component = component;
    instance.dataContext = data;
    instance.active = true;
    instance.isCloseable = isCloseable;
    this.tabsComponents.push(instance);
    this.tabGroup.selectedIndex = this.tabsComponents.length;//because we have at least 1 fixed we use total length
    this.loadinglist = false;
    return instance;

  }

  private loadTab(id: any, title: string, component, data, isCloseable = false) {

  }

  private findTabBy(id: any) {
    let index = this.tabsComponents.findIndex(item => item.id == id);
    return index;
  }

  closeTab(index: number, tab?: any) {
    event.stopPropagation();
    this.tabsComponents.splice(index, 1);
    this.tabGroup.selectedIndex = this.tabNodes.length - 1;
  }

  onSelectTab($event) {
    switch ($event.id) {
      case "tab_sitelist":

        break;
    }
  }


}
